import { render, staticRenderFns } from "./sad_reports.vue?vue&type=template&id=b9333404&lang=pug"
import script from "./sad_reports.vue?vue&type=script&lang=js"
export * from "./sad_reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports